export default "__VITE_ASSET__C8Ph8b9X__"